import { waLink } from "../../brand";

export default function FloatingWhatsApp() {
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-button"
      className="fixed bottom-5 right-5 z-50 group"
      aria-label="Hablar por WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366]/40 blur-xl scale-110 group-hover:scale-125 transition-transform" />
      <span className="relative flex items-center gap-2.5 pl-4 pr-5 h-14 rounded-full bg-[#25D366] text-white font-display font-semibold shadow-2xl shadow-[#25D366]/30 hover:scale-[1.03] transition-transform">
        <span className="w-2 h-2 rounded-full bg-white pulse-dot" />
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <path d="M19.05 4.91A10 10 0 0 0 4.91 19.05L4 22l3-1a10 10 0 0 0 12.05-15.09zm-7.05 14.6a8.5 8.5 0 0 1-4.27-1.16l-.31-.18-1.95.51.52-1.9-.2-.32a8.5 8.5 0 1 1 6.21 3.05zm4.66-6.36c-.26-.13-1.52-.75-1.76-.83s-.41-.13-.58.13-.66.83-.81 1c-.15.18-.3.2-.56.07s-1.08-.4-2.06-1.27a7.7 7.7 0 0 1-1.42-1.77c-.15-.26 0-.4.11-.53.11-.12.26-.3.39-.45.13-.15.17-.26.26-.43s.04-.32-.02-.45c-.07-.13-.58-1.4-.79-1.92s-.42-.43-.58-.44h-.5a.94.94 0 0 0-.69.32 2.86 2.86 0 0 0-.9 2.13 4.95 4.95 0 0 0 1.04 2.65 11.34 11.34 0 0 0 4.34 3.85c.6.26 1.07.42 1.44.54a3.46 3.46 0 0 0 1.59.1 2.6 2.6 0 0 0 1.7-1.2 2.1 2.1 0 0 0 .15-1.2c-.06-.11-.23-.18-.49-.31z" />
        </svg>
        <span className="hidden sm:inline text-sm">WhatsApp</span>
      </span>
    </a>
  );
}
